'use strict';
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024 from "./com.raquo.airstream.core.-Airstream-Error$.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dSignal$0024 from "./com.raquo.airstream.core.-Signal$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1 from "./scala.scalajs.runtime.-Anon-Function1.$$-Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.js";
import * as $j_scala$002eutil$002e$002dFailure from "./scala.util.-Failure.js";
import * as $j_scala$002eutil$002e$002dSuccess from "./scala.util.-Success.js";
var $p;
function $f_Lcom_raquo_airstream_core_WritableSignal__setCurrentValue__s_util_Try__V($thiz, newValue) {
  if ((!($thiz.l3() === (void 0)))) {
    $thiz.kI($j_com$002eraquo$002eairstream$002ecore$002e$002dSignal$0024.$m_Lcom_raquo_airstream_core_Signal$().PJ());
  }
  $thiz.rb(newValue);
}
export { $f_Lcom_raquo_airstream_core_WritableSignal__setCurrentValue__s_util_Try__V as $f_Lcom_raquo_airstream_core_WritableSignal__setCurrentValue__s_util_Try__V };
function $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($thiz) {
  var x = $thiz.l3();
  if ((x === (void 0))) {
    $thiz.kI($j_com$002eraquo$002eairstream$002ecore$002e$002dSignal$0024.$m_Lcom_raquo_airstream_core_Signal$().PJ());
    var nextValue = $thiz.id();
    $f_Lcom_raquo_airstream_core_WritableSignal__setCurrentValue__s_util_Try__V($thiz, nextValue);
    var $x_1 = nextValue;
  } else {
    var $x_1 = x;
  }
  return $x_1;
}
export { $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try as $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try };
function $f_Lcom_raquo_airstream_core_WritableSignal__fireValue__O__Lcom_raquo_airstream_core_Transaction__V($thiz, nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V($thiz, new $j_scala$002eutil$002e$002dSuccess.$c_s_util_Success(nextValue), transaction);
}
export { $f_Lcom_raquo_airstream_core_WritableSignal__fireValue__O__Lcom_raquo_airstream_core_Transaction__V as $f_Lcom_raquo_airstream_core_WritableSignal__fireValue__O__Lcom_raquo_airstream_core_Transaction__V };
function $f_Lcom_raquo_airstream_core_WritableSignal__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V($thiz, nextError, transaction) {
  $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V($thiz, new $j_scala$002eutil$002e$002dFailure.$c_s_util_Failure(nextError), transaction);
}
export { $f_Lcom_raquo_airstream_core_WritableSignal__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V as $f_Lcom_raquo_airstream_core_WritableSignal__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V };
function $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V($thiz, nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableSignal__setCurrentValue__s_util_Try__V($thiz, nextValue);
  var isError = nextValue.Pi();
  var elem = false;
  elem = false;
  $thiz.ea(false);
  var this$ = $thiz.ew();
  var index = 0;
  while ((index < (this$.length | 0))) {
    var observer = this$[index];
    index = ((1 + index) | 0);
    observer.fY(nextValue);
    if ((isError && (!elem))) {
      var ev$5 = true;
      elem = ev$5;
    }
  }
  var this$$1 = $thiz.ey();
  var index$1 = 0;
  while ((index$1 < (this$$1.length | 0))) {
    var observer$1 = this$$1[index$1];
    index$1 = ((1 + index$1) | 0);
    observer$1.fX(nextValue, transaction);
    if ((isError && (!elem))) {
      var ev$6 = true;
      elem = ev$6;
    }
  }
  $thiz.ea(true);
  var x = $thiz.fm();
  if ((x !== (void 0))) {
    var i = 0;
    var len = (x.length | 0);
    while ((i < len)) {
      x[i].h();
      i = ((1 + i) | 0);
    }
    x.length = 0;
  }
  if ((isError && (!elem))) {
    nextValue.eT(new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((err) => {
      $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024.$m_Lcom_raquo_airstream_core_AirstreamError$().eb(err);
    })), new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => (void 0))));
  }
}
export { $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V as $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V };
